module.exports = __webpack_public_path__ + "static/media/uso.3fbddf50.png";